import { GET, POSTJSON } from './http'
import qs from 'qs'

// 获取微信授权地址
export const getAuthorizeUrl = (params) =>
  GET('/api/weixin/panel/getAuthorizeUrl/' + params)

// 登录授权
export const getLoginAuth = (params) =>
  GET('/api/weixin/panel/loginAuth/' + params)

// 获取基础问卷
export const getBaseQuestionnaires = () =>
  GET('/api/weixin/questionnaire/getBaseQuestionnaires')

// 获取问卷列表
export const getQuestionnaires = (params) =>
  GET('/api/weixin/questionnaire/getQuestionnaires', params)

// 获取互助问卷列表
export const getUsualQuestionnaires = (params) =>
  GET('/api/weixin/questionnaire/getUsualQuestionnaires', params)

// 获取公众号id
export const getAppId = (params) => GET('/api/wechat/getAppId', params)

// 生成签名
export const getJsAPISignature = (params) =>
  GET('/api/wechat/getJsAPISignature', params)

// 更新阅读状态
export const updateRuleState = () => GET('/api/weixin/panel/updateRuleState')

// 获取个人信息
export const getPanel = () => GET('/api/weixin/panel/getPanel')

// 获取个人问卷记录列表
export const getQuestionnaireRecords = (params) =>
  GET('/api/weixin/questionnaire/getQuestionnaireRecords', params)

// 获取分享记录
export const getShareRecords = (params) =>
  GET('/api/weixin/questionnaire/getShareRecords', params)

// 提现
export const getPanelTran = (params) =>
  GET('/api/weixin/tran/PanelTran/' + params)

// 获取单个问卷信息
export const getQuestionnaire = (params) =>
  GET('/api/weixin/questionnaire/getQuestionnaire', params)

// 获取单个问卷信息
export const getAnswerState = (params) =>
  GET('/api/weixin/questionnaire/GetAnswerState', params)

// 获取下一份可答问卷链接
export const getNextQuestionnaireUrl = (params) =>
  GET('/api/weixin/questionnaire/GetNextQuestionnaireUrl', params)

// 发送短信验证码
export const sendSMS = (params) =>
GET('/api/weixin/panel/sendSMS', params)

// 绑定手机号
export const bindPhone = (params) =>
POSTJSON('/api/weixin/panel/bindPhone?'+ qs.stringify(params))